import styled from 'styled-components';
import ReactQuillEditor from '../../../../../components/Editor';

export const ReactQuillStyled = styled(ReactQuillEditor)`
  font-weight: 400;
  min-height: 10rem;

  .ql-editor {
    padding: 5px;
    margin-bottom: 5px;
    min-height: 300px;
    height: auto !important;
    overflow-y: hidden;
  }

  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-options,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }

    &.ql-font {
      .ql-picker-label,
      .ql-picker-options,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
`;
